import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import { SetInitialStateFacade } from '../../../../common';
import { AssignableCompartmentList } from '../../../../container-components';
import { AssignableCompartmentListState } from './assignable-compartments.state';
import { AssignableCompartmentListInitialState, AssignableCompartmentListLoad } from './assignable-compartments.action';

@Injectable({ providedIn: 'root' })
export class AssignableCompartmentListFacade implements SetInitialStateFacade {
  items$: Observable<AssignableCompartmentList[]> = this.store.select(
    AssignableCompartmentListState.getCompartmentList,
  );
  loaded$: Observable<boolean> = this.store.select(AssignableCompartmentListState.getLoaded);

  constructor(private store: Store) {}

  load(hubIdList: number[]): void {
    this.store.dispatch(new AssignableCompartmentListLoad(hubIdList));
  }

  setInitialState(): void {
    this.store.dispatch(new AssignableCompartmentListInitialState());
  }
}
